import * as React from 'react'

function SvgAsset37(props) {
  return (
    <svg viewBox="0 0 220 220" {...props}>
      <g id="Asset37_svg__Layer_2" data-name="Layer 2">
        <g id="Asset37_svg__Layer_1-2" data-name="Layer 1">
          <g id="Asset37_svg__Group-4">
            <path
              id="Asset37_svg__Fill-1"
              className="Asset37_svg__cls-1"
              d="M0 220h110L0 110v110z"
            />
            <path
              id="Asset37_svg__Fill-2"
              className="Asset37_svg__cls-1"
              d="M55 55l110 110H55V55z"
            />
            <path
              id="Asset37_svg__Fill-3"
              className="Asset37_svg__cls-1"
              d="M110 0v110h110L110 0z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default SvgAsset37
